import { cloneElement } from "react";
import PropTypes from "prop-types";
function CascadeContainer({
  cascadeComponents
}) {
  for (let index = cascadeComponents.length - 1; index >= 0; index--) {
    cascadeComponents[index === 0 ? 0 : index - 1] = /*#__PURE__*/cloneElement(cascadeComponents[index === 0 ? 0 : index - 1], {
      footer: index === 0 ? cascadeComponents[index + 1] : cascadeComponents[index]
    });
  }
  return cascadeComponents[0];
}
CascadeContainer.propTypes = {
  cascadeComponents: PropTypes.arrayOf(PropTypes.object).isRequired
};
export default CascadeContainer;